import { formatCurrency } from '../../functions';

export function updateTicketRow(cartItem) {
    const row = document.querySelector(
        `tr[data-ticket-id="${cartItem.id}"][data-ticket-type="${cartItem.ticketName}"]`
    );
    if (!row) {
        return;
    }

    const tds = $(row).find('td');
    if (tds.length < 4) return;

    tds.eq(0).text(cartItem.sectionName);
    tds.eq(1).text(cartItem.unSeated ? '-' : cartItem.row);
    tds.eq(2).text(cartItem.unSeated ? '-' : cartItem.seatNumber);
    const price = cartItem.unitPrice + cartItem.serviceFee;
    const priceValue = tds.eq(3).find('.price-value');
    priceValue.text(formatCurrency(price));
    priceValue.attr('data-price', price);   
    if (cartItem.seatInfo && cartItem.seatInfo !== "") {
        row.classList.add("row-no-border-bottom");
    } else {
        row.classList.remove("row-no-border-bottom");
    }

    // If seatinfo exists we need to toggle both the actual row and also update the text
    const seatInfoRow = document.getElementById(`seatinfo-ticket-id-${cartItem.id}`);
    const seatInfoSpan = document.getElementById(`seatinfo-text-${cartItem.id}`);
    if (seatInfoRow) {
        if (cartItem.seatInfo && cartItem.seatInfo !== "") {
            seatInfoRow.classList.remove("d-none");
            if (seatInfoSpan) {
                seatInfoSpan.textContent = cartItem.seatInfo;
            }
        } else {
            seatInfoRow.classList.add("d-none");
            if (seatInfoSpan) {
                seatInfoSpan.textContent = "";
            }
        }
    }

    const ariaLabel = cartItem.unSeated
        ? 'Ta bort biljett som ännu inte har en plats vald'
        : `Ta bort biljett med sektion ${cartItem.sectionName}, rad ${cartItem.row}, plats ${cartItem.seatNumber}, pris ${formatCurrency(cartItem.unitPrice + cartItem.serviceFee)} kr`;

    const triggerBtn = tds.eq(4).find('button');
    if (triggerBtn.length) {
        triggerBtn.attr('aria-label', ariaLabel);
    }

    const modalConfirmBtn = document.querySelector(`.deleteSeat[data-ticket-id="${cartItem.id}"]`);
    if (modalConfirmBtn) {
        modalConfirmBtn.setAttribute('aria-label', ariaLabel);
    }
}
export function renderCartItem(cartItem, section) {
    let template = $('#seat-template').html();
    template = template.replace('{{section}}', cartItem.unSeated ? '-' : cartItem.sectionName);

    let si = cartItem.seatInfo;
    if (si) {
        template = template.replace('{{seatInfo}}', si);
        template = template.replace('{{infoDisplay}}', '');
    } else {
        template = template.replace('{{infoDisplay}}', 'none');
    }

    if (cartItem.row) {
        template = template.replace('{{row}}', cartItem.unSeated ? '-' : cartItem.row);
        template = template.replace('{{hideRow}}', '');
    } else {
        template = template.replace('{{row}}', '');
        template = template.replace('{{hideRow}}', 'display:none;');
    }

    template = template.replace('{{seats}}', cartItem.unSeated ? '-' : cartItem.seatNumber);
    template = template.replace('{{price}}', cartItem.unSeated ? '-' : formatCurrency(cartItem.unitPrice + cartItem.serviceFee));

    if (cartItem.seasonConnectedToSubscription) {
        template = template.replace('{{price-col}}', 'd-none');
    }

    template = template.replace('{{type}}', cartItem.ticketName);

    let elementClass = '';
    if (section != null && (!section.oitems.includes(cartItem.id) || !cartItem.seatedTicket)) {
        elementClass = 'not-seatable';
    }
    template = template.replace('{{elementClass}}', elementClass);

    return template;
}

